import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { JobSearchService } from '../../../../../UI/src/app/shared/job-search/job-search.service';
import { BinsDTO, Jobsfilter } from '../../../../../UI/src/app/shared/job-search/job-results.dto';
import { JobSearchFilterComponent } from './components/job-filter/job-filter.component';
import { JobSearchLocationComponent } from './components/job-location-modal/job-location-modal.component';
import { GeoLocationService } from '../../../../../UI/src/app/shared/location/geo-location.service';
import { JobNearMeComponent } from './components/jobs-near-me/jobs-near-me.component';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';

@Component({
  selector: 'sts-page-job-search',
  templateUrl: 'job-search.component.html'
})
export class JobSearchComponent {
  public jobResults: BinsDTO = null;
  public filterData = {
    location: '',
    keywords: ''
  };
  public infiniteScrollEnabled = true;
  public sortFields = [];
  public locationFacets;
  public selectedSortField: any = null;
  public jobFilters: Jobsfilter[] = [];
  public locationFilter = {};
  private pageNumber = 0;
  private loading;
  private totalResults = 0;
  private pageCount = 20;
  private LocationFacetFieldName = 'City';
  private locationRadius = 50;
  public selectedLocationName = '';
  public distanceUnits = 'mi';
  public jobsNearMeClicked = false;
  private inprogress = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public jobSearchService: JobSearchService,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    private geoLocationService: GeoLocationService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService,
    private authenticationservice: AuthenticationService,
    public events: Events
  ) {
    this.filterData.keywords = navParams.get('searchText');
    this.filterData.location = navParams.get('loc');
    this.jobsNearMeClicked = navParams.get('jobsNearMeClicked');
    if (this.jobsNearMeClicked) {
      this.getJNMData();
    }
    else {
      this.getMatchedJobs();
    }
    if (this.authenticationservice.isUserLoggedin()) {
      this.events.publish('showSiteMapNodes', true);
    }
    else {
      this.events.publish('showSiteMapNodesPublic', true);
    }
  }

  getJNMData() {
    this.geoLocationService.getCurrentPosition().subscribe(
      (response) => {
        if (response !== undefined) {
          this.geoLocationService.setLongitide(response.coords.longitude);
          this.geoLocationService.setlatitude(response.coords.latitude);
          this.locationFilter = {
            isApplied: true,
            filterQuery: {
              'name': 'Distance',
              'searchFieldName': 'GeoLocation',
              'value': response.coords.latitude + ' ' + response.coords.longitude + ':$$:' + (this.locationRadius / 0.62137),
              'uncodedValue': ''
            }
          };
          this.jobsNearMeClicked = true;
          this.jobSearchService.fillInLocationFilter(this.locationFilter);
          const sortObj = { sortFieldName: 'Distance_Sortable', sortDirection: 'asc' };
          this.jobSearchService.setSortOrder(sortObj);
          this.getMatchedJobs();
          this.getLocationNameByLatLang(response.coords);
          this.updateLocationFilterMessage();
        }
      }, (error) => {
        this.openJobsNearMe();
      });
    }

  updateLocationFilterMessage() {
    const indexSearchIndex = this.GeoLocationSearchIndex();
    if (indexSearchIndex !== -1) {
      if (this.selectedLocationName) {
        this.translate.get('CAREER_JOBS_NEAR_ME_FILTER',
          { radius: this.locationRadius, distanceunits: this.distanceUnits, selectedlocationname: this.selectedLocationName }
        ).subscribe((res: string) => {
          this.jobFilters[indexSearchIndex].uncodedValue = res;
        });
      } else {
        this.translate.get('CAREER_JOBS_NEAR_ME_FILTER_DEFAULT',
          { radius: this.locationRadius, distanceunits: this.distanceUnits }
        ).subscribe((res: string) => {
          this.jobFilters[indexSearchIndex].uncodedValue = res;
        });
      }
    }
  }

  getLocationNameByLatLang(coords) {
    this.geoLocationService.getLocationNameByLatLang(coords).subscribe((res: string) => {
      this.selectedLocationName = res;
      this.updateLocationFilterMessage();
      this.changeDetectorRef.detectChanges();
    });
  }

  decode(value: string) {
    return decodeURI(value);
  }

  onFetchMoreResults(event) {
    if(this.inprogress)
      return;
    this.inprogress = true;  
    this.pageNumber++;    
    this.loading = this.loadingCtrl.create({
      duration: 5000
    });
    this.loading.present();
    return this.jobSearchService.fetchPagedResults((this.pageNumber - 1) * this.pageCount).then(res => {      
      if (res === true) {
        if(this.jobSearchService.getPagedJobResults() != undefined) {
          this.jobResults.resultItems.searchResults = this.jobResults.resultItems.searchResults
          .concat(this.jobSearchService.getPagedJobResults());
        }
        if (this.jobResults.resultItems.searchResults.length >= this.totalResults) {
          this.infiniteScrollEnabled = false;
        };
      }
      this.loading.dismiss();
      this.inprogress = false;
    });
  }

  ionViewWillEnter() {
    this.pageNumber = 0;
    this.jobSearchService.clearPagination();
    this.fetchSortFields();
    this.getMatchedJobs();
  }

  removeKeywords() {
    this.filterData.keywords = '';
    this.onSearch();
  }

  onSearch() {
    this.jobSearchService.fillInSearch(this.filterData.location, this.filterData.keywords);
    this.getMatchedJobs();
  }

  onFilter() {
    this.navCtrl.push(JobSearchFilterComponent, null, { direction: 'back', animation: 'ios-transition' });
  }

  openJobsNearMe() {
    const modal = this.modalCtrl.create(JobNearMeComponent);
    modal.onDidDismiss((data) => {
      if (data) {
        data.forEach(element => {
          if (element.value) {
            const facet = {
              isApplied: true, filterQuery: {
                name: element.value,
                searchFieldName: element.name,
                value: element.value
              }
            }
            this.jobSearchService.fillInLocationFilter(facet);
          }
        });
        this.getMatchedJobs();
      }
    });
    modal.present();
  }

  sortingOptionSelected(event) {
    let sortObj = this.sortFields.filter(item => item.displayName === this.selectedSortField)[0];
    if (this.selectedSortField === 'CAREER_SORT_BEST_MATCH') {
      sortObj = {
      sortFieldName : 'score',
      sortDirection : 'desc'
      }
    }
    if (sortObj) {
      this.jobSearchService.setSortOrder(sortObj);
      this.getMatchedJobs();
    }
  }

  removeFilterAt(index: number) {
    this.removeLocationIfExists(index);
    this.jobSearchService.removeFilterAt(index);
    this.ionViewWillEnter();
  }

  private fetchSortFields() {
    this.jobSearchService.fetchSortFields().then(res => {
      this.sortFields = res;
    }, (err) => {
      console.log("error occured" + err);
    });
  }

  private removeLocationIfExists(index: number) {
    if (this.filterData.location === this.jobFilters[index].uncodedValue) {
      this.filterData.location = '';
    }
  }

  private getMatchedJobs() {    
    this.loading = this.loadingCtrl.create({
      duration: 5000
    });
    this.loading.present();
    this.jobSearchService.fetchJobs(this.filterData.location, this.filterData.keywords).then((res) => {
      this.loading.dismiss();
      if (res === true) {
        this.pageNumber = 1;
        this.jobResults = this.jobSearchService.getJobResults();
        this.locationFacets = this.jobSearchService.getLocationFilters(this.LocationFacetFieldName);
        this.jobFilters = this.jobSearchService.getJobFilters();
        this.totalResults = this.jobResults == null ? 0 : this.jobResults.binCount;
      }
    });
  }
  private GeoLocationSearchIndex() {
    let indexReturn = -1;
    for (let i = 0; i < this.jobFilters.length; i++) {
      if (this.jobFilters[i].searchFieldName === 'GeoLocation') {
        indexReturn = i;
      } else {
        continue;
      }
    }
    return indexReturn;
  }
  private  getLocationAccess() {
    this.geoLocationService.getCurrentPosition().subscribe(
        (response) => {
          if (response !== undefined) {
            this.geoLocationService.setLongitide(response.coords.longitude);
            this.geoLocationService.setlatitude(response.coords.latitude);
            this.geoLocationService.setAccessCount();
          }
        }, (error) => {
        }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/job-search.component.ts